import { Duration } from 'luxon';

export const getFormattedDuration = (durationInSeconds) => {
  if (!durationInSeconds && durationInSeconds !== 0) return null;

  const duration = Duration.fromObject({ seconds: durationInSeconds })
    .shiftTo('minutes')
    .toObject();

  const minutes = Math.round(duration.minutes);
  return `${minutes?.toLocaleString()} mins`;
};

export const getFormattedDurationHoursLong = (durationInSeconds) => {
  if (!durationInSeconds && durationInSeconds !== 0) return null;

  let { hours } = Duration.fromObject({ seconds: durationInSeconds })
    .shiftTo('hours')
    .toObject();

  hours = Math.round(hours * 10) / 10;

  if (hours !== Math.round(hours)) {
    hours = hours.toFixed(1);
  }

  return `${hours} hours`;
};
